import Login from "./components/Login/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import Layout from "./components/Layout/Layout";
import { Routes, Route, Navigate } from "react-router-dom";
import RequireAuth from "./components/RequireAuth";
import UserList from "./components/User/UserList";
import AgreementForm from "./components/Agreement/AgreementForm";
import AgreementList from "./components/Agreement/AgreementList";
import AgreementShow from "./components/Agreement/AgreementShow";
import AgreementAnalyze from "./components/Agreement/AgreementAnalyze";
import AgreementEdit from "./components/Agreement/AgreementEdit";
import AgreementIndicatorEdit from "./components/Agreement/AgreementIndicatorEdit";
import UserEdit from "./components/User/UserEdit";
import UserCreate from "./components/User/UserCreate";
import AccessDenied from "./components/Layout/AccessDenied";
import UserShow from "./components/User/UserShow";
import ForgotPassword from "./components/Login/ForgotPassword";
import ResetPassword from "./components/Login/ResetPassword";
import ResendConfirmation from "./components/Login/ResendConfirmation";
import UnlockAccount from "./components/Login/UnlockAccount";
import ConfirmationAccount from "./components/Login/ConfirmationAccount";
import PublicAgreementList from "./components/Agreement/PublicAgreementList";
import HomeRedirect from "./components/HomeRedirect";
import RoleManagement from "./components/User/RoleManagment";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import GeneralSettings from "./components/User/GeneralSettings";
import ProtectedRoute from "./components/ProtectedRoutes/ProtectedRoute";


export default function App() {
  return (
    <Routes>
      {/* Rutas públicas */}
      <Route path="login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/resend-confirmation" element={<ResendConfirmation />} />
      <Route path="/unlock-account" element={<UnlockAccount />} />
      <Route path="/confirmation" element={<ConfirmationAccount />} />
      <Route path="/convenios-aprobados" element={<PublicAgreementList />} />
      <Route path="/" element={<HomeRedirect />} />

      {/* Layout general */}
      <Route path="/" element={<Layout />}>
        <Route path="/access-denied" element={<AccessDenied />} />

        {/* Dashboard: solo login */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>

        {/* Rutas de Agreements */}
        <Route
          element={
            <ProtectedRoute
              requiredPermission={{ model: "Agreement", action: "read" }}
            />
          }
        >
          <Route path="/agreements" element={<AgreementList />} />
          <Route
            path="/agreement/show/:agreementId"
            element={<AgreementShow />}
          />
        </Route>
        <Route
          element={
            <ProtectedRoute
              requiredPermission={{ model: "Report", action: "create" }}
            />
          }
        >
          <Route
            path="/agreement/analyze/:agreementId"
            element={<AgreementAnalyze />}
          />
        </Route>

        <Route
          element={
            <ProtectedRoute
              requiredPermission={{ model: "Agreement", action: "create" }}
            />
          }
        >
          <Route path="/agreement/new" element={<AgreementForm />} />
        </Route>

        <Route
          element={
            <ProtectedRoute
              requiredPermission={{ model: "Agreement", action: "update" }}
            />
          }
        >
          <Route path="/agreement/edit" element={<AgreementEdit />} />
        </Route>

        {/* Indicadores */}
        <Route
          element={
            <ProtectedRoute
              requiredPermission={{ model: "Indicator", action: "update" }}
            />
          }
        >
          <Route
            path="/agreement/edit/indicator"
            element={<AgreementIndicatorEdit />}
          />
        </Route>

        {/* Rutas de Usuarios */}
        <Route
          element={
            <ProtectedRoute
              requiredPermission={{ model: "User", action: "read" }}
            />
          }
        >
          <Route path="/users" element={<UserList />} />
          <Route path="/user/show/:id" element={<UserShow />} />
        </Route>

        <Route
          element={
            <ProtectedRoute
              requiredPermission={{ model: "User", action: "create" }}
            />
          }
        >
          <Route path="/user/new" element={<UserCreate />} />
        </Route>

        <Route
          element={
            <ProtectedRoute
              requiredPermission={{ model: "User", action: "update" }}
            />
          }
        >
          <Route path="/user/edit/:id" element={<UserEdit />} />
        </Route>

        <Route
          path="/agreement/analyze/:agreementId"
          element={<AgreementAnalyze />}
        />

        {/* Roles y permisos */}
        <Route
          element={
            <ProtectedRoute
              requiredPermission={{
                model: "Role",
                action: "manage_permissions",
              }}
            />
          }
        >
          <Route path="/user/new_rol_managment" element={<RoleManagement />} />
        </Route>

        {/* Configuración general: cualquier usuario logueado */}
        <Route element={<ProtectedRoute />}>
          <Route path="/user/profile" element={<UserShow />} />
          <Route path="/user/general_settings" element={<GeneralSettings />} />
        </Route>
      </Route>
    </Routes>
  );
}
